import PendingPage from './PendingPage';

// Exportar somente o PendingPage (não o FormPage)
export default PendingPage; 